import React, { Component } from 'react';
import { Formik, Form } from 'formik';
import moment from 'moment';

import DatePickerField from "../forms/DatePickerField";

import AccountTimesheetTable from "./widgets/AccountTimesheetTable"

export class TimesheetByPayWeek extends Component {
    static displayName = TimesheetByPayWeek.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            payWeek: this.getFriday()
        };

        this.props.store.updateBanner("Timesheet by Pay Week");
        
        this.updatePayWeek = this.updatePayWeek.bind(this);
    }

    getFriday() {    
        var date = new Date();

        if (date.getDay() === 7) {
            return date
        }
        else {
            var newDate = new Date();
            date.setDate(newDate.getDate() + (7 + 5 - newDate.getDay()) % 7);
        
            return date;
        }
    }


    render() {
        return (
            <div>
                <div className="row">
                    {this.displayDateRange()}
                </div>
                <div className="row">
                    {this.displayTimesheets()}
                </div>
            </div>
        )
    }


    updatePayWeek(value) {
        this.setState({ payWeek: value })
    }


    displayDateRange() {
        return (
            <div className="col-12 col-md-8">
                <Formik
                    onSubmit={(values) => true}
                    initialValues={{ payWeek: this.state.payWeek }}
                >
                    <Form>
                        <DatePickerField name="payWeek" onChange={this.updatePayWeek} onlyShowFridays={true} label="Pay Week" />
                    </Form>
                </Formik>
            </div>
        );
    }


    displayTimesheets() {
        if (this.state.payWeek) {

            let accounts_with_timesheets_in_range = this.props.store.accounts.collection.map(account => {
                account = account.include(["student", "timestamp", "timesheet"])

                let timesheets = account.timesheets;

                if (timesheets) {
                    timesheets = timesheets.filter((timesheet) => {
                        let payWeekObject = moment(this.state.payWeek)
                        return (timesheet !== undefined) && timesheet.isFinal
                            && (timesheet.weekEndDateObject.isSame(payWeekObject, "day"))
                    });
                    account.timesheets = timesheets;
                }
                else {
                    account.timesheets = []
                }

                return account;
            });


            return (
                <AccountTimesheetTable 
                    showStudentName={true}
                    accounts={accounts_with_timesheets_in_range} 
                    showCertifiedDate={true} 
                    showSubmittedDate={true} 
                    showCertified={true} 
                    store={this.props.store} />
            );
        }
        else {
            return (
                <div className="well">
                    Please select a date range above to find timesheets.
            </div>
            )
        }
    }

}
